
import Vue, { PropType } from 'vue';

import { TYPES } from './types';

import SimpleStencil from './SimpleStencil.vue';
import ButtonStencil from './ButtonStencil.vue';

const MAP = {
  simple: SimpleStencil,
  button: ButtonStencil,
};

export default Vue.extend({
  name: 'AppSkeleton',
  functional: true,
  props: {
    type: {
      type: String as PropType<typeof TYPES[number]>,
      required: true,
      validator: (val) => TYPES.includes(val),
    },
  },
  render(h, { props, data }) {
    return h(MAP[props.type], data);
  },
});
